import { createContext } from 'react';

export type SessionData = { profileId: string; sessionId: string };

export const SessionContext = createContext<SessionData>({ profileId: '', sessionId: '' });
